import React, { useContext } from "react";
import Buttons from "../button/Buttons";
import SearchBar from "../../../components/ui/searchBar/SearchBar";
import Iconify from "../../../layouts/components/iconify/iconify";
import DarkModeContext from "../../../utils/Context/DarkModeContext";
import { getCardInfo } from "../../../lib/getCardInfo";
import CardSectionSkeleton from "./CardSectionSkeleton";

function CardSection({
  isContentLoading,
  children,
  cardTitle,
  rightButton,
  buttonClassName,
  titleButtonClick,
  buttonText,
  searchInput,
  searchInputName,
  textWithIcon,
  iconImg,
  handleChange,
  fontIcon,
  iconName,
  iconVector,
  cardFooter,
  footerContent,
  showListView,
  showCardView,
  viewType,
  isShorting,
  multipleButton,
  rightButtonArray,
  customHeader,
  headerContentWrapper,
  cardInfo,
  cardInfoWrapper,
  hasRefreshButton,
  onRefresh,
}) {
  const { isDarkMode } = useContext(DarkModeContext);

  return (
    <>
      {cardInfo && (
        <div className="card-section-info">
          {cardInfo ? getCardInfo(cardInfoWrapper) : null}
        </div>
      )}

      <div
        className={`card-section ${isDarkMode ? "dark-mode" : ""} ${
          cardTitle ? "card-section-left" : ""
        }${searchInput && rightButton ? "card-section-between" : ""}${
          rightButton ? " card-button-only" : ""
        }`}
      >
        {customHeader ? (
          <div className="card-top-title-btn">{headerContentWrapper} </div>
        ) : (
          (cardTitle || rightButton || searchInput) && (
            <div className="card-top-title-btn">
              {cardTitle ? (
                <div className="section-title mb-0">
                  <Iconify icon={iconVector} />
                  {cardTitle}
                </div>
              ) : null}
              <div className="d-flex align-items-center w-100 justify-content-end">
                {searchInput ? (
                  <div className="card-search-input">
                    <SearchBar
                      searchText={searchInputName}
                      handleChange={handleChange}
                    />
                  </div>
                ) : null}
                {hasRefreshButton ? (
                  <div className="refresh-btn">
                    <Buttons
                      buttonTypeClassName={"theme-btn"}
                      onClick={onRefresh}
                      buttonText={""}
                      textWithIcon={true}
                      fontIcon={true}
                      iconName={"ic:sharp-refresh"}
                      titleText={"Refresh"}
                    />
                  </div>
                ) : null}
                {rightButton && (
                  <div className="btn-right-sec d-flex align-items-center">
                    {isShorting && (
                      <div className="shorting-tabs mr-2">
                        <div
                          className={`view-items grid-list ${
                            viewType === "list" ? "active" : ""
                          }`}
                          title="List View"
                          onClick={showListView}
                        >
                          <Iconify icon="line-md:list-3-filled" />
                        </div>
                        <div
                          className={`view-items card-list ${
                            viewType === "card" ? "active" : ""
                          }`}
                          title="Card View"
                          onClick={showCardView}
                        >
                          <Iconify icon="mdi:view-grid" />
                        </div>
                      </div>
                    )}
                    {multipleButton && (
                      <div className="btn-right-sec">
                        {rightButtonArray.map((button, index) => (
                          <Buttons
                            key={index}
                            buttonTypeClassName={button.buttonTypeClassName}
                            onClick={button.onClick}
                            buttonText={button.buttonText}
                            textWithIcon={button.textWithIcon}
                            iconName={button.iconName}
                            fontIcon={button.fontIcon}
                          />
                        ))}
                      </div>
                    )}
                    <Buttons
                      buttonTypeClassName={buttonClassName}
                      onClick={titleButtonClick}
                      buttonText={buttonText}
                      textWithIcon={textWithIcon}
                      imagePath={iconImg}
                      iconName={iconName}
                      fontIcon={fontIcon}
                    />
                  </div>
                )}
              </div>
            </div>
          )
        )}
        <div className="card-body-sec">
          {isContentLoading ? <CardSectionSkeleton /> : children}
        </div>
        {cardFooter && <div className="card-footer-sec">{footerContent}</div>}
      </div>
    </>
  );
}

export default CardSection;
